var styles = {
  "icon": "_icon_aiq2o3_4",
  "sizeXS": "_sizeXS_aiq2o3_14",
  "sizeS": "_sizeS_aiq2o3_18",
  "sizeM": "_sizeM_aiq2o3_22",
  "sizeL": "_sizeL_aiq2o3_26",
  "light": "_light_aiq2o3_30",
  "dark": "_dark_aiq2o3_34",
  "allVariants": "_allVariants_aiq2o3_48",
  "variant16": "_variant16_aiq2o3_53",
  "variant20": "_variant20_aiq2o3_54",
  "variant24": "_variant24_aiq2o3_55",
  "variant28": "_variant28_aiq2o3_58"
};
export { styles as default };
